import { Patient, PatientQuery } from '@dreryk/egabinet-patient-frontend-api';
import { AppointmentDetails, AppointmentDetailsQuery } from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { useCqrsFind, useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';
import { commonTranslationKeys } from '@dreryk/react-common';

type PatientUnconfirmedUpdatePanelLoaderRenderProps = Readonly<{
   appointment: AppointmentDetails | null;
   patient: Patient;
}>;

type PatientUnconfirmedUpdatePanelLoaderProps = Readonly<{
   appointmentId: number | undefined;
   children: (renderProps: PatientUnconfirmedUpdatePanelLoaderRenderProps) => JSX.Element;
   patientId: number;
}>;

export const PatientUnconfirmedUpdatePanelLoader = (props: PatientUnconfirmedUpdatePanelLoaderProps): JSX.Element => {
   const { data: patient, loading: patientLoading, error: patientError } = useCqrsGet<Patient>(() => {
      const query = new PatientQuery();
      query.id = Slot.of(props.patientId);
      return query;
   });

   const { data: appointment, loading: appointmentLoading, error: appointmentError } = useCqrsFind<AppointmentDetails>(
      () => {
         const query = new AppointmentDetailsQuery();

         if (props.appointmentId) {
            query.appointmentId = AppointmentId.of(props.appointmentId);
         }
         return query;
      },
      {
         enabled: Boolean(props.appointmentId),
      }
   );

   if (patientLoading || appointmentLoading) {
      return <LoaderSpinner />;
   }

   if (patientError || appointmentError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({ appointment: appointment, patient: patient });
};
